import { FC } from 'react';

import { Formik } from 'formik';
import { BaseDateTimePicker, BaseInput, FormBodyContainer } from 'wbs-components-lib';

import { ExportWinStreaksFormProps } from './types';
import { exportWinStreaksFormValidationSchema } from './validationSchema';

export const ExportWinStreaksForm: FC<ExportWinStreaksFormProps> = ({
  initialValues,
  onSubmit,
  isSubmitting = false,
  submitButtonCaption = 'Export',
}) => (
  <Formik
    initialValues={initialValues}
    onSubmit={onSubmit}
    validationSchema={exportWinStreaksFormValidationSchema}
    enableReinitialize
  >
    {({ submitForm, values, handleChange, handleBlur, setFieldValue, errors, touched }) => {
      const { startDate: startDateValue, endDate: endDateValue, limit: limitValue } = values;
      const { startDate: startDateError, endDate: endDateError, limit: limitError } = errors;
      const { startDate: isStartDateTouched, endDate: isEndDateTouched, limit: isLimitTouched } = touched;

      const onSubmit = async () => {
        await submitForm();
      };

      const isStartDateError = isStartDateTouched && !!startDateError;
      const isEndDateError = isEndDateTouched && !!endDateError;
      const isLimitError = isLimitTouched && !!limitError;

      return (
        <FormBodyContainer isSubmitting={isSubmitting} onSubmit={onSubmit} submitButtonCaption={submitButtonCaption}>
          <BaseDateTimePicker
            id="startDate"
            name="startDate"
            errorMessage={isStartDateError ? (startDateError as string) : undefined}
            caption="Start Date"
            onBlur={handleBlur}
            value={startDateValue}
            onChange={(value) => setFieldValue('startDate', value)}
          />
          <BaseDateTimePicker
            id="endDate"
            name="endDate"
            errorMessage={isEndDateError ? (endDateError as string) : undefined}
            caption="End Date"
            onBlur={handleBlur}
            value={endDateValue}
            onChange={(value) => setFieldValue('endDate', value)}
          />
          <BaseInput
            helperText={isLimitError && limitError}
            label="Enter Limit"
            id="limit"
            name="limit"
            type="number"
            value={limitValue}
            onBlur={handleBlur}
            onChange={handleChange}
            error={isLimitError}
          />
        </FormBodyContainer>
      );
    }}
  </Formik>
);
